import { defineComponent as _defineComponent } from 'vue';
import Textarea from 'primevue/textarea';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'InputTextarea',
    props: {
        id: {
            type: String,
            default: 'input-text',
        },
        type: {
            type: String,
            default: 'text',
        },
        modelValue: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        vuelidateObject: {
            type: Object,
            default: undefined,
        },
        submitted: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const invalid = computed(() => props.vuelidateObject ? props.vuelidateObject.$invalid : false);
        const errors = computed(() => props.vuelidateObject ? props.vuelidateObject.$errors : null);
        const error = computed(() => props.vuelidateObject ? props.vuelidateObject.$error : null);
        const __returned__ = { props, invalid, errors, error, get Textarea() { return Textarea; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
